import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { TableColumn, TableFilterOptionValue } from '../components/table/table.component';
import { IImpersonation } from '../interfaces/IImpersonation';
import { INotification } from '../interfaces/INotification';
import { DatePipe } from '../pipes/date.pipe';
import { ButtonComponent } from '../components/button/button.component';
import { ImpersonationDialogComponent } from '../components/impersonation/impersonation-dialog/impersonation-dialog.component';

export const sessionExpiryWarning = {
  title: 'controlCenter.sessionExpiryTitle',
  desc: 'controlCenter.sessionExpiryWarning',
  confirmationBtnText: 'auth.refreshSession',
};

export const userImpersonatedNotification: INotification = {
  type: 'Success',
  desc: 'notifications.impersonation.userImpersonated',
  title: 'header.userSettings.impersonation.impersonation',
};

export const userImpersonationStoppedNotification: INotification = {
  type: 'Success',
  desc: 'notifications.impersonation.impersonationStopped',
  title: 'header.userSettings.impersonation.impersonation',
};

export const userImpersonationFailedNotification: INotification = {
  type: 'Error',
  desc: 'notifications.impersonation.impersonationFailed',
  title: 'header.userSettings.impersonation.impersonation',
};

export const impersonationTableSettings = {
  displayedColumns: ['parentName', 'validFrom', 'validTo', 'delete'],
};

export function getImpersonationColumns(
  translateService: TranslateService,
  impersonationComponent: ImpersonationDialogComponent,
): TableColumn<IImpersonation>[] {
  const datePipe = new DatePipe(translateService);
  return [
    {
      name: 'default.name',
      sortable: true,
      selector: 'parentName',
      filterable: true,
      filterType: 'search',
      row: (row: IImpersonation) => row.parentName,
    },
    {
      name: 'header.userSettings.impersonation.validFrom',
      sortable: true,
      selector: 'validFrom',
      filterable: true,
      filterType: 'search',
      filterDisplayFn: (value: string) => (value ? datePipe.transform(value) : ''),
      filterFn: (values: TableFilterOptionValue[], row: IImpersonation) => values.includes(datePipe.transform(row.validFrom)),
      row: (row: IImpersonation) => datePipe.transform(row.validFrom),
    },
    {
      name: 'header.userSettings.impersonation.validTo',
      sortable: true,
      selector: 'validTo',
      filterable: true,
      filterType: 'search',
      filterDisplayFn: (value: string) => (value ? datePipe.transform(value) : ''),
      filterFn: (values: TableFilterOptionValue[], row: IImpersonation) => values.includes(datePipe.transform(row.validTo)),
      row: (row: IImpersonation) => datePipe.transform(row.validTo),
    },
    {
      name: 'default.delete',
      component: ButtonComponent,
      componentInit: (instance: ButtonComponent<any>, row: IImpersonation) => {
        instance.row = row;
        instance.iconName = 'delete';
        instance.buttonClick.pipe(tap(() => impersonationComponent.deleteEntry(row))).subscribe();
      },
    },
  ];
}
